<!-- eslint-disable vue/no-unused-components -->

<template>
  <div class="status-settings">
    <CreateNewStatusModal :create_new_status.sync="modals.create_new_status" :update_status.sync="modals.update_status"
      :update_status_data="modals.update_status_data" :module="this.module" v-on:closeModal="closeModal()" />
    <base-header class="pb-6">
      <b-row class="py-3">
        <b-col lg="6" cols="7">
          <p class="text-muted">Settings</p>
          <h2 class="text-xl d-inline-block mb-0">Status Settings</h2>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header class="border-0">
          <b-row></b-row>
        </b-card-header>

        <b-col cols="12">
          <b-row class="d-flex align-items-center justify-content-md-between">
            <b-col cols="12" md="8" class="d-md-flex">
              <base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler" placeholder="Search">
              </base-input>
            </b-col>
          </b-row>
        </b-col>

        <div class="table-listings">
          <el-table :data="tableData" style="width: 100%" @selection-change="selectionChange" class="mt-4"
            v-loading="isTableLoading">
            <el-table-column type="selection" width="45"></el-table-column>

            <el-table-column label="Status Name" sortable min-width="150">
              <template slot-scope="scope">
                <p class="top-line text-primary">{{ scope.row.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Status Group" sortable min-width="150" v-if="module != 'disbursement'">

              <template slot-scope="scope">
                <p>{{ scope.row.group_name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Main Status" sortable min-width="150" v-if="module != 'disbursement'">

              <template slot-scope="scope">
                <p class="top-line text-primary">{{ scope.row.main_status || '-' }}</p>
              </template>
            </el-table-column>

            <el-table-column label="TAT Day" sortable min-width="150">

              <template slot-scope="scope">
                <p :class="{ 'text-danger': scope.row.stop_tat }">{{ scope.row.tat_day }} days</p>
              </template>
            </el-table-column>

            <el-table-column label="Created By" sortable min-width="150">

              <template slot-scope="scope">
                <p>{{ scope.row.created_by || '-' }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Date Created" sortable min-width="150">

              <template slot-scope="scope">
                <p>{{ scope.row.created_at | dateFormatString }}</p>
              </template>
            </el-table-column>

            <el-table-column fixed="right" width="25" align="center" class-name="px-0">

              <template slot-scope="scope">
                <el-dropdown trigger="click" style="cursor: pointer">
                  <p class="el-dropdown-link mb-0 top-line">
                    <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
                  </p>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="updateOpenModal(scope.row)">
                      <!-- Eye Icon -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                        <path fill="#13663E"
                          d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
                      </svg>
                      Edit
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="remove(scope.row.id)" v-if="!readOnlyItem.includes(scope.row.name)">
                      <span class="text-danger">
                        <!-- Trash-Can Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#DF3030"
                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                        </svg>
                        Delete
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Switch } from 'element-ui'
import CreateNewStatusModal from '@/views/StatusSettings/StatusModals/CreateNewStatusModal'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce, swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';

export default {
  mixins: [clientPaginationMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BasePagination,
    CreateNewStatusModal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Switch.name]: Switch,
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      mode: 'listing',
      selectedRows: [],
      searchText: '',
      isTableLoading: false,
      debouncedHandler: '',
      TableColumn: [{
        type: 'selection'
      }],
      modals: {
        create_new_status: false,
        update_status: false,
        update_status_data: {}
      },
      module: '',
			readOnlyItems:[
				{
					module: 'disbursement',
					names: ['Pending Disbursement','Partial Disbursement','Full Disbursement']
				}
			]
    }
  },
  mounted() {
    this.debouncedHandler = debounce(() => {
      // this.searchFinancialProposalList();
    }, 500);
  },
  computed: {
    watchModule() {
      return this.$route.params.module;
    },
		readOnlyItem(){
			let item = this.readOnlyItems.find(itm => itm.module == this.module);
			return _gHlp.getValue(item,'names',[]);
		}
  },
  created() {
    this.module = this.$route.params.module;
    this.getListing();
  },
  watch: {
    watchModule: {
      handler(newVal) {
        this.module = newVal;
        this.getListing();
      }
    }
  },
  methods: {
    ...mapActions(useCommonStore, ['deleteStatus', 'getStatusList']),
    getListing() {
      this.getStatusList({
				search:{
					module:this.module
				}
			}).then(resp => {
        this.tableData = resp.data;
      });
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    openModal() {
      this.modals.create_new_status = true;
    },
    closeModal() {
      this.modals.create_new_status = false;
      this.modals.update_status = false;
      this.getListing();
    },
    updateOpenModal(status) {
      this.modals.update_status_data = status;
      this.modals.update_status = true;
    },
    remove(id) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteStatus(id).then(resp => {
            this.getListing();
            _gNotif.notifySuccess('<b>Status: </b> - Successfully Deleted.')
          });
        }
      })

    }
  }
}
</script>